export default __webpack_public_path__ + "static/media/banner.fe86cc5c.jpeg";